"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOCALE_CONFIG = exports.ICONS = exports.DEFAULT_LOCALE = void 0;
var ICONS = {
  CHECK_ICON: 'CheckIcon',
  TIMER_ICON: 'TimerIcon'
};
exports.ICONS = ICONS;
var LOCALE_CONFIG = {
  month: 'short',
  day: 'numeric',
  year: 'numeric'
};
exports.LOCALE_CONFIG = LOCALE_CONFIG;
var DEFAULT_LOCALE = 'en-GB';
exports.DEFAULT_LOCALE = DEFAULT_LOCALE;